import React, { useState, useEffect } from "react";
import menu from "../../hooks/menu.json";
import { useLocation, Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";

const AplicacionesListado = () => {

    const [data, setData] = useState({});
    const { pathname } = useLocation();
    const [meta, setMeta] = useState({});

    useEffect(() => {
        let id = pathname.split('/').pop();
        let item = menu[1].items.find(item => item.id == id);
        if (item) {
            setMeta({
                title: item.name || 'Aplicaciones',
                description: item.content || 'Aplicaciones',
                canonical: 'https://' + window.location.host + pathname,
                meta: {
                    charset: 'utf-8',
                    name: {
                        keywords: `aplicaciones, listado, ${item.name}, ${item.content}`
                    }
                }
            });
            setData(item);
        }
    }, [pathname]);

    return (
        <DocumentMeta {...meta}>
            <div className="page-title-area ptb-100">
                <div className="container">
                    <div className="page-title-content">
                        <h1>{data.name || 'Aplicaciones'}</h1>
                        <p className="text-info">{data.type || ''}</p>
                    </div>
                </div>
                <div className="bg-image">
                    <img src={process.env.PUBLIC_URL + "/assets/img/banner/title_" + (data.id || 'agroindustria') + ".jpg"} alt="" />
                </div>
            </div>
            <div class="service-single-area pt-100" style={{ minHeight: 600 }}>
                <section id="services" className="service-section-three">
                    <div className="container">
                        <div className="row justify-content-center">
                            {data.items && data.items.map((item) => (<div className="col-lg-4 col-md-6">
                                <div className="item-single mb-30" key={item.id}>
                                    <div className="image" style={{ maxHeight: '150px' }}>
                                        <Link to={"/aplicaciones/" + data.id + "/" + item.id}>
                                            <img src={process.env.PUBLIC_URL + "/assets/img/aplicaciones/" + item.image} alt="" loading="lazy" />
                                        </Link>
                                    </div>
                                    <div className="content">
                                        <h5><Link to={"/aplicaciones/" + data.id + "/" + item.id}>{item.name}</Link></h5>
                                    </div>
                                    <div className="spacer"></div>
                                </div>
                            </div>))}
                        </div>
                    </div>
                </section >
            </div >
        </DocumentMeta>
    );
}

export default AplicacionesListado;